import { Box, Skeleton } from '@mui/material';
import SwaggerUI from 'swagger-ui-react';

import 'swagger-ui-react/swagger-ui.css';
import './swagger-overrides.css';
import { BackToTop } from 'shared/ui/BackToTop';

interface SwaggerDisplayProps {
  swaggerJson: any;
  isLoading: boolean;
}

const SwaggerDisplaySkeleton = () => {
  return (
    <Box sx={{ flex: 1, marginTop: '20px', width: '100%', maxWidth: '1460px' }}>
      <Skeleton
        variant="rectangular"
        sx={{ width: '40%', height: '40px', marginBottom: '15px' }}
      />
      {[1, 2, 3].map((i) => (
        <Box
          key={i}
          sx={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}
        >
          <Skeleton
            variant="rectangular"
            sx={{ width: '80px', height: '30px', marginRight: '10px' }}
          />
          <Skeleton
            variant="text"
            sx={{ width: 'calc(100% - 90px)', height: '30px' }}
          />
        </Box>
      ))}
    </Box>
  );
};

const SwaggerDisplay = ({ swaggerJson, isLoading }: SwaggerDisplayProps) => {
  if (isLoading) {
    return <SwaggerDisplaySkeleton />;
  }

  if (!swaggerJson) {
    return null;
  }

  return (
    <Box sx={{ marginTop: '-33px' }}>
      <SwaggerUI spec={swaggerJson} />
      <BackToTop containerId="right_side_page" />
    </Box>
  );
};

export { SwaggerDisplay };
